import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useBankStore = defineStore("bank", () => {
  const currentBank = ref(
    localStorage.getItem("eye-academy-last-bank-used") || null
  );

  // Add computed property for two-way binding
  const getCurrentBank = computed({
    get: () => currentBank.value,
    set: (newValue) => updateBank(newValue),
  });

  const updateBank = (newBank) => {
    currentBank.value = newBank;
    localStorage.setItem("eye-academy-last-bank-used", newBank);
  };

  return { currentBank: getCurrentBank, updateBank };
});
